import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@/services/api';

export const usePresalesCreate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: any) => {
      const res = await request.post('/presales', data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['presales-list'] });
      queryClient.invalidateQueries({ queryKey: ['presales-by-course'] });
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    }
  });
};

export const usePresalesUpdate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, data }: { id: string, data: any }) => {
      const res = await request.patch(`/presales/${id}`, data);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['presales-list'] });
      queryClient.invalidateQueries({ queryKey: ['presales-by-course'] });
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    }
  });
};

export const usePresalesDelete = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      const res = await request.delete(`/presales/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['presales-list'] });
      queryClient.invalidateQueries({ queryKey: ['presales-by-course'] });
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    }
  });
};
